"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterReducer = exports.initialState = void 0;
exports.initialState = {
    rooms: [],
    sqm_price: [],
    area: [],
    floor: [],
    availability: [],
};
var filterReducer = function (state, action) {
    var _a;
    if (action.type === 'update') {
        return __assign(__assign({}, state), (_a = {}, _a[action.payload.name] = action.payload.value, _a));
    }
    if (action.type === 'resetSQMPrice') {
        return __assign(__assign({}, state), { sqm_price: [] });
    }
    return state;
};
exports.filterReducer = filterReducer;
